import BaseStore from 'stores/BaseStore';
import { observable, action } from 'mobx'

class FieldStore extends BaseStore {
  constructor() {
    super('customFields', 'customField', { site_model: true })
  }

  @observable
  formsToSync = []


  @action
  setFormsToSync(value) {
    this.formsToSync = value
  }

  @action
  resetFormsToSync() {
    this.formsToSync = []
  }
}

export default new FieldStore();
